import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth, units } from '@calm-web/design-system';

export const BackButton = styled.div`
	margin: 0;
	display: flex;
	cursor: pointer;
	align-items: center;
`;

export const BackButtonText = styled.div`
	text-transform: capitalize;
	${fontWeight(FontWeights.Demi)}
	margin-left: ${units(1.25)};
	${fontSize(FontSizes.base)}
	line-height: 150%;
	color: ${palette('gray5')};

	${minWidth('tablet')} {
		font-size: ${units(1.78)};
	}
`;
